import SelectorEngine from '../../utils/dom/selector-engine';
import EventHandler from '../../utils/dom/event-handler';
import Modal from '../../components/Modal';
import Request from '../../utils/request';

const SELECTOR_PAGE = '.js-my-favourites';

const SELECTOR_EDIT_MATCH_DETAILS_BUTTON = ".js-edit-match-default-trigger";

const SELECTOR_CLOSE_MATCH_DETAILS_BUTTON = ".js-exit-my-defaults-modal";

const SELECTOR_CANCEL_MATCH_DETAILS_BUTTON = ".js-cancel-my-defaults-modal";

const SELECTOR_SAVE_MATCH_DETAILS_BUTTON = ".js-save-my-defaults-modal";

const SELECTOR_EDIT_MATCH_DEFAULT = "#match-default-edit-modal";

const EVENT_CLICK = `click`;

class FavouriteDefault {
	constructor() {
		this.state = {
			results: [{
				defaultSport: '',
				defaultBallColor: '',
				defaultCategory: ''
			}]
		};
		this._myContactId = undefined;
		this.init();
	}

	init() {
		this._wrapperElement = SelectorEngine.findOne(SELECTOR_PAGE);
		if (!this._wrapperElement) {
			return;
		}
		this._myContactId = this._wrapperElement.getAttribute('data-my-favourites-contact-id');
		this.fetchDefaults();
		const forms = document.querySelectorAll('#manual-default-game-param-section .game-default--form-element');
		this._editMatchModal = new Modal(SelectorEngine.findOne(SELECTOR_EDIT_MATCH_DEFAULT, this._wrapperElement), {});
		this._editMatchDefaultButton = SelectorEngine.findOne(SELECTOR_EDIT_MATCH_DETAILS_BUTTON, this._wrapperElement);
		this._closeMatchDefaultButton = SelectorEngine.findOne(SELECTOR_CLOSE_MATCH_DETAILS_BUTTON, this._wrapperElement);
		this._cancelMatchDefaultButton = SelectorEngine.findOne(SELECTOR_CANCEL_MATCH_DETAILS_BUTTON, this._wrapperElement);
		this._saveMatchDefaultButton = SelectorEngine.findOne(SELECTOR_SAVE_MATCH_DETAILS_BUTTON, this._wrapperElement);

		EventHandler.on(this._editMatchDefaultButton, EVENT_CLICK, () => {
			this.showMatchEditModal();
		});

		EventHandler.on(this._closeMatchDefaultButton, EVENT_CLICK, () => {
			this.hideMatchEditModal();
		});

		EventHandler.on(this._cancelMatchDefaultButton, EVENT_CLICK, () => {
			this.hideMatchEditModal();
		});

		EventHandler.on(this._saveMatchDefaultButton, EVENT_CLICK, () => {
			this.saveMatchDetails();
		});

		forms.forEach((form) => {
			form.addEventListener('change', (event) => {
				this.defaultsForm(event);
			});
		});
	}

	async fetchDefaults() {
		const results = await Request.get(`/api/selfsubmission/getDefaultParameters?contactid=${this._myContactId}`).catch((e) => {
			if (e.errors.errorCode == '99') {
				return false;
			}
		});

		if (results.errors.errorcode == '00') {
			const defaultContainer = SelectorEngine.findOne('.my-game-defaults', this._wrapperElement);
			defaultContainer.querySelector('.defaultSport span').innerText = results.response.defaults.sport;
			defaultContainer.querySelector('.defaultBallColor span').innerText = results.response.defaults.ballColor;
			defaultContainer.querySelector('.defaultCategory span').innerText = results.response.defaults.matchCategory;
			if (results.response.defaults.sport == 'Padel') {
				defaultContainer.querySelector('.defaultBallColor').classList.add('u-hidden');
			} else if (results.response.defaults.sport == 'Tennis') {
				defaultContainer.querySelector('.defaultBallColor').classList.remove('u-hidden');
			}
		}
		return
	}

	defaultsForm(event) {
		const defaultContainer = SelectorEngine.findOne('.my-game-defaults', this._wrapperElement);
		let inputChanged = event.target;
		if (inputChanged.value == 'Tennis' || inputChanged.value == 'Padel') {
			this.state.results[0].defaultSport = inputChanged.value;
		} else if (inputChanged.value == 'Yellow' || inputChanged.value == 'Green' || inputChanged.value == 'Orange' || inputChanged.value == 'Red') {
			this.state.results[0].defaultBallColor = inputChanged.value;
		} else if (inputChanged.value == 'Friendly' || inputChanged.value == 'Competition') {
			this.state.results[0].defaultCategory = inputChanged.value;
		}
		// hide Ball color section if padel is selected.
		if (this.state.results[0].defaultSport == 'Padel') {
			defaultContainer.querySelector('.defaultBallColor').classList.add('u-hidden');
			document.querySelector('#default-game-details').classList.add('u-hidden');
			SelectorEngine.findOne("input[name='defaultBallColor'][value=" + this.state.results[0].defaultBallColor + "]", this._wrapperElement).checked = false;
		} else if (this.state.results[0].defaultSport == 'Tennis') {
			defaultContainer.querySelector('.defaultBallColor').classList.remove('u-hidden');
			document.querySelector('#default-game-details').classList.remove('u-hidden');
		}
	}

	showMatchEditModal() {
		this._editMatchModal.show();
	}

	hideMatchEditModal() {
		this._editMatchModal.hide();
	}

	async saveMatchDetails() {
		if (this.state.results[0].defaultSport == 'Tennis') {
			if (this.state.results[0].defaultSport != '' && this.state.results[0].defaultBallColor != '' && this.state.results[0].defaultCategory != '') {
				let defaultData;
				defaultData = Object.assign({}, {
					"contactId": this._myContactId,
					"sport": this.state.results[0].defaultSport,
					"ballColor": this.state.results[0].defaultBallColor,
					"matchCategory": this.state.results[0].defaultCategory
				});

				const defaults = await Request.post('/api/selfsubmission/updateDefaultParam', defaultData).catch((e) => {
					if (e.errors.errorCode == '99') {
						return false;
					}
				});

				if (defaults.errors.errorcode == '00') {
					this.hideMatchEditModal();
					this.fetchDefaults();
				}
			} else {
				document.getElementById('default-details-error-section').classList.remove('u-hidden');
				setTimeout(() => {
					document.getElementById('default-details-error-section').classList.add('u-hidden');
				}, 5000);
				return false;
			}
		} else if (this.state.results[0].defaultSport == 'Padel') {
			if (this.state.results[0].defaultSport != '' && this.state.results[0].defaultCategory != '') {
				let defaultData;
				defaultData = Object.assign({}, {
					"contactId": this._myContactId,
					"sport": this.state.results[0].defaultSport,
					"matchCategory": this.state.results[0].defaultCategory
				});

				const defaults = await Request.post('/api/selfsubmission/updateDefaultParam', defaultData).catch((e) => {
					if (e.errors.errorCode == '99') {
						return false;
					}
				});

				if (defaults.errors.errorcode == '00') {
					this.hideMatchEditModal();
					this.fetchDefaults();
				}
			} else {
				document.getElementById('default-details-error-section').classList.remove('u-hidden');
				setTimeout(() => {
					document.getElementById('default-details-error-section').classList.add('u-hidden');
				}, 5000);
				return false;
			}
		} else {
			document.getElementById('default-details-error-section').classList.remove('u-hidden');
			setTimeout(() => {
				document.getElementById('default-details-error-section').classList.add('u-hidden');
			}, 5000);
			return false;
		}
	}
}

const globalFavouriteDefault = new FavouriteDefault();
export default globalFavouriteDefault;
